export const isValidFloat = (value?: string) => (value && Number.isNaN(parseFloat(value)) ? 'global.not_a_valid_float' : undefined)
